import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, Input,
  PLATFORM_ID, Inject, ViewEncapsulation } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { Product } from "../../../classes/product";
import {
  productDetailQueryParams,
  productDetailRouterLink
} from '../../../../core/utils/product-detail-route.util';

@Component({
  selector: 'app-quick-view',
  templateUrl: './quick-view.component.html',
  styleUrls: ['./quick-view.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class QuickViewComponent implements OnInit, OnDestroy  {

  @Input() product: Product;
  @Input() currency: any;
  @ViewChild("quickView", { static: false }) QuickView: TemplateRef<any>;

  public closeResult: string;
  public ImageSrc: string;
  public modalOpen: boolean = false;

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private router: Router, private modalService: NgbModal) { }

  ngOnInit(): void {
  }

  openModal() {
    this.ImageSrc = undefined;
    this.modalOpen = true;
    if (isPlatformBrowser(this.platformId)) {
      this.modalService.open(this.QuickView, {
        size: 'lg',
        scrollable: true,
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'Quickview'
      }).result.then((result) => {
        `Result ${result}`
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  }

  goToProductDetail(modal: { dismiss: (reason?: string) => void }): void {
    if (!this.product) {
      return;
    }
    modal.dismiss('Ver detalle');
    this.router.navigate(
      productDetailRouterLink(this.product),
      { queryParams: productDetailQueryParams(this.product) }
    );
  }

  displaySpec(value: string | undefined | null): string {
    const trimmed = `${value ?? ''}`.trim();
    return trimmed || '—';
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  Color(variants) {
    if (!variants?.length) {
      return [];
    }
    const uniqColor = []
    for (let i = 0; i < Object.keys(variants).length; i++) {
      if (uniqColor.indexOf(variants[i].color) === -1 && variants[i].color) {
        uniqColor.push(variants[i].color)
      }
    }
    return uniqColor
  }

  Size(variants) {
    if (!variants?.length) {
      return [];
    }
    const uniqSize = []
    for (let i = 0; i < Object.keys(variants).length; i++) {
      if (uniqSize.indexOf(variants[i].size) === -1 && variants[i].size) {
        uniqSize.push(variants[i].size)
      }
    }
    return uniqSize
  }

  ChangeVariants(color, product) {
    if (!product?.variants?.length || !product?.images?.length) {
      return;
    }
    product.variants.map((item) => {
      if (item.color === color) {
        product.images.map((img) => {
          if (img.image_id === item.image_id) {
            this.ImageSrc = img.src
          }
        })
      }
    })
  }

  ngOnDestroy() {
    if(this.modalOpen){
      this.modalService.dismissAll();
    }
  }

}
